var ScrollMagic = ScrollMagic || {};

(function ($) {
  Drupal.behaviors.perfectionistProGlowHeroV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $thisModule = $('.js-perfectionist-pro-hero-glow', context);
      var $videoContainer = $thisModule.find('.js-perfectionist-pro-glow-hero-desktop-container');
      var $heroTextLeft = $videoContainer.find('.js-perfectionist-pro-glow-hero-desktop-text-container-left');
      var $heroTextRight = $videoContainer.find('.js-perfectionist-pro-glow-hero-desktop-text-container-right');
      var $pageHeader = $('.page-header');
      var heroVideo = $videoContainer.find('.js-perfectionist-pro-glow-hero-desktop-image')[0];
      var videoLength = $videoContainer.find('.js-perfectionist-pro-glow-hero-desktop-image').data('vid-length');
      var playbackSpeed = 250;
      var videoHeight;
      var scrollingHeight;
      var heroVideoFlag = false;

      heroVideo.addEventListener('timeupdate', function () {
        if (this.currentTime > 2.9) {
          $heroTextLeft.addClass('perfectionist-pro-glow-hero-desktop-text-container-left__hiding');
          $heroTextRight.addClass('perfectionist-pro-glow-hero-desktop-text-container-right__showing');
        }
        if (this.currentTime < 2.9) {
          $heroTextLeft.removeClass('perfectionist-pro-glow-hero-desktop-text-container-left__hiding');
          $heroTextRight.removeClass('perfectionist-pro-glow-hero-desktop-text-container-right__showing');
        }
      });

      // Scrolling video inialise and function call
      heroVideo.currentTime = 0;
      if (heroVideoFlag === false) {
        // iPad video initialise
        heroVideo.load();
        initiateVideoScrolling();
        heroVideoFlag = true;
      }

      function createPinOneScene() {
        var headerHeight = parseInt($pageHeader.height());
        var controller = new ScrollMagic.Controller({
          globalSceneOptions: {
            triggerHook: 'onLeave',
            duration: scrollingHeight
          }
        });

        return new ScrollMagic.Scene({
          triggerElement: '.js-perfectionist-pro-glow-hero-desktop-container',
          offset: -headerHeight
        })
          .setPin('.js-perfectionist-pro-glow-hero-desktop-container', { pushFollowers: true })
          .addTo(controller);
      }

      // Scrolling video functionality.
      function initiateVideoScrolling() {
        var frameNumber = 0;
        var moduleOffsetVal = $thisModule.offset().top;
        var yOffset = 0;

        videoHeight = Math.ceil(videoLength) * playbackSpeed;
        scrollingHeight = videoHeight;
        createPinOneScene();
        $thisModule.addClass('perfectionist-pro-glow__visible');
        // For smoother video playback, debounce is excluded.
        $(window).on('scroll', function () {
          yOffset = window.pageYOffset - moduleOffsetVal;
          frameNumber = yOffset / playbackSpeed;
          if (frameNumber < heroVideo.duration) {
            heroVideo.currentTime = frameNumber;
          }
        });
      }
    }
  };
})(jQuery);
